import { Entity, field, rootCollection } from 'firebase-firestorm/lib'

@rootCollection({ name: 'glCodeUPC' })
export class GLCodeUPC extends Entity {
  @field({ name: 'id' })
  id!: string

  @field({ name: 'upc' })
  upc!: string

  @field({ name: 'restaurantId' })
  restaurantId!: string

  @field({ name: 'glCode' })
  glCode!: string
}
